import { render, staticRenderFns } from "./MatterTable.vue?vue&type=template&id=7fe44a65&scoped=true"
import script from "./MatterTable.vue?vue&type=script&lang=js"
export * from "./MatterTable.vue?vue&type=script&lang=js"
import style0 from "./MatterTable.vue?vue&type=style&index=0&id=7fe44a65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe44a65",
  null
  
)

export default component.exports